import { render, staticRenderFns } from "./autoPaymentForCompany.vue?vue&type=template&id=235b9474&scoped=true"
import script from "./autoPaymentForCompany.vue?vue&type=script&lang=js"
export * from "./autoPaymentForCompany.vue?vue&type=script&lang=js"
import style0 from "./autoPaymentForCompany.vue?vue&type=style&index=0&id=235b9474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235b9474",
  null
  
)

export default component.exports